import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "../../../shared/api/base-query";
import { pagedQueryFn } from "../../../shared/api/paged-query-fn";

interface ITechOperationScalarsDto {
  id: string;
  operationParamId: number;
  name: string;
  formulation: string;
  isActive: boolean;
  paramArgs: {
    [key: string]: number;
  };
  description: string;
  techOperationSubGroupId: string;
  deletedAt: number;
  isDeleted: boolean;
  createdAt: number;
  updatedAt: number;
  createdByUserId: string;
  updatedByUserId: string;
}

export const techOperationScalarsApi = createApi({
  reducerPath: "techOperationScalarsApi",
  baseQuery,
  endpoints: (builder) => ({
    fetchTechOperationScalars: builder.query<ITechOperationScalarsDto[], void>({
      queryFn: pagedQueryFn<ITechOperationScalarsDto, ITechOperationScalarsDto[]>(
        { url: "TechOperationScalarsV2" },
        (dtos) => dtos
      ),
    }),
  }),
});

export const { useFetchTechOperationScalarsQuery } = techOperationScalarsApi;
